/* src/app/features/leilao/consulta-status-leilao/consulta-status-leilao.component.scss */
/*# sourceMappingURL=consulta-status-leilao.component.css.map */
